import React from 'react';

interface Props {
    size: number;
}
const Spacer: React.FC<Props> = ({size}) => {
  return <div style={{height: size}} />;
}

export default Spacer;